var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCDjobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3656_9835",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0117188,
    y: 0.349609,
    width: 29.2032,
    height: 32.4053,
    fill: "url(#pattern0_3656_9835)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3656_9835)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.2352,
    cy: 20.8541,
    rx: 22.0165,
    ry: 27.8483,
    fill: "#1DBF73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3656_9835",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3656_9835",
    transform: "matrix(0.00866912 0 0 0.0078125 -0.0548239 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3656_9835",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADsQAAA7EB9YPtSQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATlSURBVHic7ZzNi5VVHMc/pjgiZFhaFCkWE6QmlBnRhHBctYjcT5FBVH9B2KI2LmvTTrCoBisVWkZFqwQriIxaZBmYTFPYi70wLXoba1qcc2GKmeeZ5/XcO9/vBw6Xy3Ofc3/PuZ/7nOe8QjEBmHdqJYWSss7CZbkDMHmxAOJYAHEsgDgWQBwLIM6ahucfB2baCGQFsBWYzB1E2wRGsG2bicAIlpWrAHEsgDgWQBwLII4FEMcCiGMBxLEA4lgAcSyAOBZAHAsgjgUQxwKI06UAgfrDo2Xnemp3S/gOII4FEMcCiGMBxLEA4lgAcZpOCy9iGjhUcrzuubmYzh1A3wTE2sUNCIxgWbkKEMcCiGMBxLEA4lgAcSyAOB4O9nCwUcYCiGMBxLEA4lgAcSyAOB4OrsZ07gD6JiDWLm5AYATLylWAOBZAHAsgjgUQxwKIYwHE8XCwh4ONMhZAHAsgjgUQxwKIYwHE8XBwNaZzB9A3AbF2cQ0mgMPARYrL6mL63F15wqxHwAIsxS7gTep1KL0B3NJ/yNUJWIDFeAz4i2a9inPAE30HXpWABVjIauAV2u1ePpryHUoCFmDAKuB5uhljmEr5Dx0BCzDgIN38+IP0eH+XsnwCFgDgZuB3uhXgD2BnXxc0wB1By+MwsK7kM/8Ax4D7gOuAsfS6HziRjhcxBjzbLMz2CfgOcDvl/94vgdtK8tkNnF9GXmX59ErAAkxR/uNvXmZeV1MuwYvthd6cgLYAq4DvWPr6/6b6P3ZPOm+pPC/QY4vAzwDF7ASuKTh+Avi4Yp6ngdcKjl8LbK+YZ20sQDE7So4fq5lv2XkWYEgoq9s/qpnv6ZLjRXedVulyODgXW4HJlvLaV3L8YWJ9XpWyrt/9wOU18l2M48BM3ZMDo/cQGOi2w2bUUigqLFcB4lgAcSyAOBZAHAsgjgUQR1GAfcS+9pWSyvoqClEUwCzAAohjAcSxAOJYAHEsgDiKAozlDqBlGl2PogAHcgfQMg81OVlRgPuJS7zW5w6kIeuBF2g4+UVRAIBHgDPAo8DazLFUZS1xdfIZ4oykRqgKALANeA44BzwJjGeNppxx4CniOoQjxPg7J6A1JexD4pr9O8i/ZHt1iuMgMa5OpoStxEmhTdiTEsCvwCngPeAT4FPg6w6/ewtx15BbgbuBvcCGDr8PsABFbADuTWnAL0QRzhNluAB8A3wP/ARcIorzJ/Ab8UFtLOW1BriKOOX7euLC0S3ADcTtZjZ2fUGLYQGqsZH4z9ybO5C2UH4INGgK8BINFkoMGV8Rr6c2igIcJTapDgDvEp+UR4l5YtwPAjcRr6c2qs8Ac8DLKY0DDxB39tjNcG7WNE9ch/g68CqxL6AVVAVYyDnitrSHiEuz7yE+5E0Q9wbKxVliE/QU8DZxn4LWsQD/5VvijiBT6f0VRAl2pNftKW2jnbKbI9bjn6d0Fvgsvc62kH8pFqCYWeCDlP7PlcTl45tSmiD22i3FM8D7wI8p/UDsV8iKBajPzyl9kd7PUizAW8DJjmOqjGIrwCzAAohjAcSxAOJYAHEsgDhNm4HvtBLFyuAkw9mNXIjvAOJYAHEsgDgWQBwLII4FEKesGTgDPN1HIC1Stln0JHBnT7H0wY25Axg2Avk3aB6mFIoKy1WAOBZAHAsgjgUQxwKIYwHE+RceVDHOkEOsHAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCDjobs);
export default __webpack_public_path__ + "static/media/CDjobs.04cf258cbd5a1e472f49fc5d071f8968.svg";
export { ForwardRef as ReactComponent };